// Action enums
export enum ActionTypes {
  UPDATE_TRACKING_STATE = "UPDATE_TRACKING_STATE",
  TRACK_PAGE_VIEW = "TRACK_PAGE_VIEW",
  TRACK_EVENT = "TRACK_EVENT",
}
